import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PublicHeader from "../components/header";
import {
  isValidEmail,
  isValidMobileNumber,
  isValidMobileNumberWithcode,
} from "../components/ValidationServices";
import APIService from "../components/postServices";
import { showToast } from "../components/toastServices";
import { RadioButton } from "primereact/radiobutton";
import { Button } from "primereact/button";
import { ToastContainer } from "react-toastify";
import { formatNumber } from "../components/DateFormatServices";

const breadcrumb = [
  { label: "Entrance Exam Result", url: "/entranceExamResult" },
];

function RegPay() {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  const [ApplicationData, setApplicationData] = useState(null);
  // Use a single useEffect to handle setting ApplicationData and redirection
  useEffect(() => {
    const data = location.state?.data;

    if (data) {
      setApplicationData(data);
    } else {
      navigate("/");
    }
  }, [location.state, navigate, ApplicationData]);
  console.log("PaymentForm", ApplicationData);

  const [StudentData, setStudentData] = useState(null);

  console.log("StudentData", StudentData);

  const [dobVerificationData, setDobVerificationData] = useState({});
  const [PaymentFormData, setPaymentFormData] = useState({});

  useEffect(() => {
    if (ApplicationData) {
      setDobVerificationData({
        ApplicationNo: ApplicationData.applicationNo,
        Dob: "",
        academicYear: ApplicationData.academicYear,
      });

      setPaymentFormData({
        Amount: "",
        BillingName: ApplicationData.addressee
          ? ApplicationData.addressee
          : ApplicationData.fatherName
          ? ApplicationData.fatherName
          : ApplicationData.motherName, // Parent name
        BillingAddress: "",
        BillingCity: "",
        BillingState: "",
        BillingZip: "",
        BillingCountry: "",
        BillingTel: ApplicationData.mobileNumber,
        BillingEmail: ApplicationData.emailAddress,
        MerchantParam1: "Admission Fee", // Company ID
        MerchantParam2: "", // School ID
        MerchantParam3: ApplicationData.name, //Student name
        MerchantParam4: "", // Fee2
        MerchantParam5: ApplicationData.applicationNo, // App no
        CustomerIdentifier: ApplicationData.applicationNo,
        paymentOption: "",
        AcademicYear: ApplicationData.academicYear,
        Class: ApplicationData.class,
      });
    }
  }, [ApplicationData]);

  const [CCAvenuePaymentSetup, setCCAvenuePaymentSetup] = useState();

  useEffect(() => {
    APIService.get(`/CCAvenuePayment/CCAvenuePaymentSetup`)
      .then((response) => {
        setCCAvenuePaymentSetup(response.data.dataSet);
      })
      .catch((error) => {
        // Handle API call errors here
        console.error("Error:", error);
      });
  }, []);
  console.log(PaymentFormData);

  const [UserformError, setFormError] = useState({});
  const [error, setError] = useState(false);
  const [errors, setErrors] = useState({});
  const [verify, setVerify] = useState(false);

  const UserformDataChange = (event) => {
    const { name, value } = event.target;
    // Update the form state with the new value
    setDobVerificationData({
      ...dobVerificationData,
      [name]: value,
    });

    // Perform validation on the fly and update the errors state
    const newErrors = {
      ...errors,
      [name]:
        name === "emailAddress"
          ? value !== "" && !isValidEmail(value)
          : !isValidMobileNumber(value),
    };
    setErrors(newErrors);
  };

  const PaymentformDataChange = (event) => {
    const { name, value } = event.target;
    // Update the form state with the new value
    setPaymentFormData({
      ...PaymentFormData,
      [name]: value,
    });

    // Perform validation on the fly and update the errors state
    const newErrors = {
      ...errors,
      [name]:
        name === "BillingEmail"
          ? value !== "" && !isValidEmail(value)
          : name === "BillingTel"
          ? value !== "" && !isValidMobileNumber(value)
          : "",
    };

    setErrors(newErrors);
  };

  const handleError = (error, input) => {
    setFormError((prevState) => ({ ...prevState, [input]: error }));
    setError(true);
  };

  console.log("PaymentFormData", PaymentFormData);

  const VerifyDob = async (e) => {
    e.preventDefault();
    setLoading(true);
    let isValid = true;
    let dob = dobVerificationData.Dob;

    if (!dob) {
      handleError("Please insert date of birth", "Dob");
      isValid = false;
      setLoading(false);
    }
    if (isValid) {
      try {
        const response = await APIService.Post(
          // `/SelectionProcess/VerifyDateOfBirth`,
          `/SelectionProcess/ApplicantDobVerification`,
          dobVerificationData
        );
        console.log("responseCode", response.responseCode);
        if (response.responseCode === 1) {
          setStudentData(response.dataSet);
          //
          setPaymentFormData({
            ...PaymentFormData,
            Amount: response.dataSet.classAmount,
          });
          setVerify(true);
          setLoading(false);
        }
      } catch (error) {
        console.error("Error fetching company data:", error);
        setLoading(false);
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    if (StudentData) {
      setPaymentFormData({
        ...PaymentFormData,

        BillingAddress: StudentData.applicationDetails.address1,
        BillingCity: StudentData.applicationDetails.city,
        BillingState: StudentData.applicationDetails.stateDesc,
        BillingZip: StudentData.applicationDetails.postCode,
        BillingCountry: StudentData.applicationDetails.country,
      });
    }
  }, [StudentData]);

  const makePayment = async (e) => {
    e.preventDefault();
    console.log("makePayment");
    setLoading(true);
    let isValid = true;

    // let applicationNo = StudentformData.no;
    let BillingTel = PaymentFormData.BillingTel;
    let BillingEmail = PaymentFormData.BillingEmail;
    let Amount = PaymentFormData.Amount;
    let paymentOption = PaymentFormData.paymentOption;

    if (!BillingTel) {
      handleError("Please input mobile number", "BillingTel");
      isValid = false;
    }
    if (!BillingEmail) {
      handleError("Please input Email", "BillingEmail");
      isValid = false;
    }

    if (!Amount) {
      handleError("Please input Amount", "Amount");
      isValid = false;
    }

    if (!paymentOption) {
      handleError("Please select payment option", "paymentOption");
      isValid = false;
    }

    if (isValid) {
      try {
        const response = await APIService.Post(
          `/CCAvenuePayment/admissionFeePaymentInitiate`,
          PaymentFormData
        );
        console.log("response", response);
        if (response.responseCode === 1) {
          console.log("response", response);
          setLoading(false);

          // initiateTransaction(response.dataSet);
          // navigate("/Payment", {
          //   state: { data: "/entranceExamResult" },
          //   replace: true,
          // });
          navigate("/Payment", {
            state: {
              data: response.dataSet,
              link: "/entranceExamResult",
              status: "payment",
            },
            replace: true,
          });
        }
      } catch (error) {
        showToast("error", error.response.data.responseMessage);
      }
    }
    setLoading(false);
  };

  return (
    <div className="main-page">
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <PublicHeader breadcrumb={breadcrumb} title={"Entrance Exam Result"} />
      <div className="content-wrapper  mt-10">
        <div className="col-md-12  reg">
          <div className="box-header text-center">
            <h3 className="box-title">ADMISSION - FEE PAYMENT</h3>
          </div>

          <br />
          <div className="">
            <div className=" reg">
              {/* <div className="box-header">
                <h3 className="box-title">Information</h3>
              </div> */}
              <div className="">
                <div className="row">
                  <div className="col-12 md:col-12 xl:col-6">
                    <div className="form-group row">
                      <label className="col-12 md:col-12 xl:col-4 col-form-label">
                        Application No. :
                      </label>
                      <label className="col-12 md:col-12 xl:col-8 col-form-label">
                        {ApplicationData && ApplicationData.applicationNo} /{" "}
                        {ApplicationData && ApplicationData.academicYear}
                      </label>
                    </div>

                    <div className="form-group row">
                      <label className="col-12 md:col-12 xl:col-4 col-form-label">
                        Student Name :
                      </label>
                      <label className="col-12 md:col-12 xl:col-8 col-form-label">
                        {ApplicationData && ApplicationData.name}
                        {/* {ApplicationData.middleNameOfStudent
                          ? ` ${ApplicationData.middleNameOfStudent}`
                          : ""}
                        {ApplicationData.lastNameOfStudent
                          ? ` ${ApplicationData.lastNameOfStudent}`
                          : ""} */}
                      </label>
                    </div>

                    <div className="form-group row">
                      <label className="col-12 md:col-12 xl:col-4 col-form-label">
                        Father's Name :
                      </label>
                      <label className="col-12 md:col-12 xl:col-8 col-form-label">
                        {ApplicationData && ApplicationData.fatherName
                          ? `${ApplicationData && ApplicationData.fatherName}`
                          : ""}
                      </label>
                    </div>

                    <div className="form-group row">
                      <label className="col-12 md:col-12 xl:col-4 col-form-label">
                        Mother's Name :
                      </label>
                      <label className="col-12 md:col-12 xl:col-8 col-form-label">
                        {ApplicationData && ApplicationData.motherName
                          ? `${ApplicationData && ApplicationData.motherName}`
                          : ""}
                      </label>
                    </div>
                  </div>
                  <div className="col-12 md:col-12 xl:col-6">
                    <h4 className="text-red m-0">
                      Enter the date of birth and verify to continue...
                    </h4>

                    <div className="form-group row">
                      <label className="col-12 md:col-12 xl:col-4">
                        Date Of Birth
                        <i aria-hidden="true" style={{ color: "red" }}>
                          *
                        </i>
                      </label>
                      <div className="col-12 md:col-12 xl:col-4">
                        <div className="input-group">
                          <input
                            type="date"
                            className="form-control form-control-sm"
                            id="Dob"
                            name="Dob"
                            value={dobVerificationData.Dob}
                            onChange={UserformDataChange}
                            // onBlur={handleDobBlur}
                            onFocus={() => handleError(null, "Dob")}
                          />
                        </div>
                        {error && UserformError.Dob && (
                          <div className="text-red">{UserformError.Dob}</div>
                        )}
                      </div>
                      <div className="col-12 md:col-12 xl:col-4">
                        <Button
                          label="Verify"
                          severity="danger"
                          icon="pi pi-check"
                          loading={loading}
                          onClick={VerifyDob}
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-12 md:col-12 xl:col-4 col-form-label">
                        Mobile Number{" "}
                        <i aria-hidden="true" style={{ color: "red" }}>
                          *
                        </i>{" "}
                        :
                      </label>
                      <div className="col-12 md:col-12 xl:col-8">
                        <div className="input-group">
                          <input
                            type="tel"
                            className={`form-control form-control-sm ${
                              errors.BillingTel ? "is-invalid" : ""
                            }`}
                            placeholder="Mobile Number"
                            id="BillingTel"
                            name="BillingTel"
                            value={PaymentFormData.BillingTel}
                            onChange={PaymentformDataChange}
                            onFocus={() => handleError(null, "BillingTel")}
                          />
                        </div>
                        {errors.BillingTel && (
                          <div className="invalid-feedback">
                            Invalid mobile number
                          </div>
                        )}
                        {error && UserformError.BillingTel && (
                          <div className="text-red">
                            {UserformError.BillingTel}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-12 md:col-12 xl:col-4 col-form-label">
                        Email{" "}
                        <i aria-hidden="true" style={{ color: "red" }}>
                          *
                        </i>{" "}
                        :
                      </label>
                      <div className="col-12 md:col-12 xl:col-8">
                        <div className="input-group">
                          <input
                            type="tel"
                            className={`form-control form-control-sm ${
                              errors.BillingEmail ? "is-invalid" : ""
                            }`}
                            placeholder="Email"
                            id="BillingEmail"
                            name="BillingEmail"
                            value={PaymentFormData.BillingEmail}
                            onChange={PaymentformDataChange}
                            onFocus={() => handleError(null, "BillingEmail")}
                          />
                        </div>
                        {errors.BillingEmail && (
                          <div className="invalid-feedback">
                            Invalid email address
                          </div>
                        )}
                        {error && UserformError.BillingEmail && (
                          <div className="text-red">
                            {UserformError.BillingEmail}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-12 md:col-12 xl:col-4 col-form-label">
                        Amount{" "}
                        <i aria-hidden="true" style={{ color: "red" }}>
                          *
                        </i>{" "}
                        :
                        <br />
                        <b className="text-red">
                          (Total Due : <span>&#8377;</span> {/* ₹ */}{" "}
                          {StudentData && formatNumber(StudentData.classAmount)}
                          )
                        </b>
                      </label>
                      <div className="col-12 md:col-12 xl:col-8">
                        <div className="input-group">
                          <input
                            type="tel"
                            className={`form-control form-control-sm ${
                              errors.Amount ? "is-invalid" : ""
                            }`}
                            placeholder="Amount"
                            id="Amount"
                            name="Amount"
                            value={PaymentFormData.Amount}
                            onChange={PaymentformDataChange}
                            onFocus={() => handleError(null, "Amount")}
                          />
                        </div>
                        {error && UserformError.Amount && (
                          <div className="text-red">{UserformError.Amount}</div>
                        )}
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-12 md:col-12 xl:col-4 col-form-label">
                        Payment option{" "}
                        <i aria-hidden="true" className="ml-2 redColor">
                          {" "}
                          *{" "}
                        </i>
                        :
                      </label>
                      <div className="col-12 md:col-12 xl:col-8">
                        <RadioButton
                          inputId="ingredient1"
                          name="paymentOption"
                          value="OPTCRDC"
                          onChange={PaymentformDataChange}
                          checked={PaymentFormData.paymentOption === "OPTCRDC"}
                          onFocus={() => handleError(null, "paymentOption")}
                        />

                        <label className="ml-2 mr-2">Credit Card</label>
                        <br />
                        <RadioButton
                          inputId="ingredient1"
                          name="paymentOption"
                          value="OPTDBCRD"
                          onChange={PaymentformDataChange}
                          checked={PaymentFormData.paymentOption === "OPTDBCRD"}
                          onFocus={() => handleError(null, "paymentOption")}
                        />

                        <label className="ml-2 mr-2">Debit Card</label>
                        <br />
                        <RadioButton
                          inputId="ingredient1"
                          name="paymentOption"
                          value="OPTNBK"
                          onChange={PaymentformDataChange}
                          checked={PaymentFormData.paymentOption === "OPTNBK"}
                          onFocus={() => handleError(null, "paymentOption")}
                        />

                        <label className="ml-2">Net Banking</label>
                        <br />
                        <RadioButton
                          inputId="ingredient1"
                          name="paymentOption"
                          value="OPTUPI"
                          onChange={PaymentformDataChange}
                          checked={PaymentFormData.paymentOption === "OPTUPI"}
                          onFocus={() => handleError(null, "paymentOption")}
                        />

                        <label className="ml-2">UPI</label>

                        {error && UserformError.paymentOption && (
                          <div className="text-red">
                            {UserformError.paymentOption}
                          </div>
                        )}
                      </div>
                    </div>
                    <br />
                    <div
                      className="button-container"
                      style={{ justifyContent: "center" }}
                    >
                      <Button
                        label=" Make Payment"
                        severity="danger"
                        loading={loading}
                        onClick={makePayment}
                        disabled={!verify}
                        style={{ width: "250px" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RegPay;
